export const environment = {
  production: false,
  APIURL: "https://api.n-a-s.mx/v1/",
  API_ENDPOINT: "https://api.n-a-s.mx/v1/",
  SOCKET: "wss://api.n-a-s.mx/ws/front-end/",
  FRONT: "https://n-a-s.mx/",
  LOCAL_APIURL: "http://127.0.0.1:8000/v1/",
  LOCAL_API_ENDPOINT: "http://127.0.0.1:8000/v1/",
  LOCAL_SOCKET: "ws://127.0.0.1:8000/ws/front-end/",
  LOCAL_FRONT: "http://127.0.0.1:8000/",
  firebaseConfig: {
    apiKey: "AIzaSyB89wUtJ7hhtQn_0bSvky2Mfy37MxgZOnc",
    authDomain: "nas-firebase-dev.firebaseapp.com",
    projectId: "nas-firebase-dev",
    storageBucket: "nas-firebase-dev.firebasestorage.app",
    messagingSenderId: "740706149169",
    appId: "1:740706149169:web:8855d6b940f07d292e4610",
    measurementId: "G-RBS964W3TH"
  },
  apikeyMap: "AIzaSyDxRvvy4w3KKblJ8TSW75T1VDy2qVtWIiw",
  PK_STRIPE:
    "sk_test_51TgCIm18ou8sr4vOPthoMOPkC2MNVzFw7I4E0Ri64gacswXptMjen5ck7m1ibe1QR6XOg86g47NBhJgWdimXLwup002La5wOHF"
};
